const u = '.sl-button-group{display:inline-flex;gap:0}.sl-button-group--horizontal{flex-direction:row}.sl-button-group--vertical{flex-direction:column}:host([orientation="vertical"])::slotted(sl-button){display:block;width:100%}:host([orientation="horizontal"])::slotted(sl-button:not(:first-child)){margin-left:-1px}:host([orientation="vertical"])::slotted(sl-button:not(:first-child)){margin-top:-1px}::slotted(sl-button:hover){position:relative;z-index:1}@media (max-width:640px){.sl-button-group--responsive{flex-direction:column;width:100%}:host([responsive])::slotted(sl-button){width:100%;margin:0 !important;margin-top:var(--sl-spacing-1) !important}:host([responsive])::slotted(sl-button:first-child){margin-top:0 !important}}';
class l extends HTMLElement {
  constructor() {
    super(), this._slotObserver = null, this._buttonClickHandlers = /* @__PURE__ */ new Map(), this._shadow = this.attachShadow({ mode: "open" }), this._container = document.createElement("div"), this._render();
  }
  static get observedAttributes() {
    return ["type", "orientation", "size", "value", "responsive"];
  }
  connectedCallback() {
    this._setupButtons(), this._observeSlot();
  }
  disconnectedCallback() {
    this._slotObserver?.disconnect(), this._slotObserver = null, this._buttonClickHandlers.forEach((t, e) => {
      e.removeEventListener("click", t), e.removeAttribute("data-group-setup");
    }), this._buttonClickHandlers.clear();
  }
  attributeChangedCallback(t, e, s) {
    e !== s && this._updateGroup();
  }
  get type() {
    return this.getAttribute("type") || "button";
  }
  set type(t) {
    this.setAttribute("type", t);
  }
  get orientation() {
    return this.getAttribute("orientation") || "horizontal";
  }
  set orientation(t) {
    this.setAttribute("orientation", t);
  }
  get size() {
    return this.getAttribute("size") || "default";
  }
  set size(t) {
    this.setAttribute("size", t);
  }
  get value() {
    return this.getAttribute("value") || "";
  }
  set value(t) {
    this.setAttribute("value", t);
  }
  get responsive() {
    return this.hasAttribute("responsive");
  }
  set responsive(t) {
    t ? this.setAttribute("responsive", "") : this.removeAttribute("responsive");
  }
  _updateGroup() {
    if (!this._container) return;
    const t = ["sl-button-group", `sl-button-group--${this.orientation}`];
    this.responsive && t.push("sl-button-group--responsive"), this._container.className = t.join(" "), this._container.setAttribute("role", this.type === "radio" ? "radiogroup" : (this.type === "checkbox", "group")), this.setAttribute("orientation", this.orientation), this.responsive ? this.setAttribute("responsive", "") : this.removeAttribute("responsive"), this._propagateToButtons(), this._updateButtonPositions();
  }
  _propagateToButtons() {
    this.querySelectorAll("sl-button").forEach((e) => {
      const s = e;
      this.size && this.size !== "default" && s.setAttribute("size", this.size);
    });
  }
  _updateButtonPositions() {
    const t = Array.from(this.querySelectorAll("sl-button")), e = this.orientation;
    t.forEach((s, o) => {
      const i = s;
      i.setAttribute("data-group-orientation", e), t.length === 1 ? i.setAttribute("data-group-position", "only") : o === 0 ? i.setAttribute("data-group-position", "first") : o === t.length - 1 ? i.setAttribute("data-group-position", "last") : i.setAttribute("data-group-position", "middle");
    });
  }
  _setupButtons() {
    this._shadow.querySelector("slot") && ((this.type === "radio" || this.type === "checkbox") && this._setupToggleBehavior(), this._propagateToButtons(), this._updateButtonPositions());
  }
  _setupToggleBehavior() {
    this.querySelectorAll("sl-button[value]").forEach((e) => {
      const s = e;
      if (s.hasAttribute("data-group-setup")) return;
      s.setAttribute("data-group-setup", "true");
      const o = s.getAttribute("value");
      this.value.split(",").includes(o || "") ? s.setAttribute("checked", "") : s.removeAttribute("checked");
      const r = (n) => {
        n instanceof CustomEvent && (this.type === "radio" ? (this.value = o || "", this._updateRadioSelection(o || "")) : this.type === "checkbox" && this._toggleCheckbox(o || ""));
      };
      s.addEventListener("click", r), this._buttonClickHandlers.set(s, r);
    });
  }
  _updateRadioSelection(t) {
    this.querySelectorAll("sl-button[value]").forEach((s) => {
      const o = s;
      o.getAttribute("value") === t ? o.setAttribute("checked", "") : o.removeAttribute("checked");
    }), this.dispatchEvent(
      new CustomEvent("sl-buttongroup-change", {
        bubbles: !0,
        composed: !0,
        detail: { value: t }
      })
    );
  }
  _toggleCheckbox(t) {
    const e = this.value ? this.value.split(",").filter((i) => i) : [], s = e.indexOf(t);
    s > -1 ? e.splice(s, 1) : e.push(t), this.value = e.join(","), this.querySelectorAll("sl-button[value]").forEach((i) => {
      const r = i, n = r.getAttribute("value");
      e.includes(n || "") ? r.setAttribute("checked", "") : r.removeAttribute("checked");
    }), this.dispatchEvent(
      new CustomEvent("sl-buttongroup-change", {
        bubbles: !0,
        composed: !0,
        detail: { value: e }
      })
    );
  }
  _observeSlot() {
    this._shadow.querySelector("slot") && (this._slotObserver = new MutationObserver(() => {
      this._setupButtons();
    }), this._slotObserver.observe(this, { childList: !0, subtree: !0 }));
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${u}</style>
      <div class="sl-button-group sl-button-group--${this.orientation}" role="${this.type === "radio" ? "radiogroup" : "group"}">
        <slot></slot>
      </div>
    `, this._container = this._shadow.querySelector("div");
  }
}
typeof customElements < "u" && !customElements.get("sl-button-group") && customElements.define("sl-button-group", l);
export {
  l as SlButtonGroupElement
};
//# sourceMappingURL=sl-button-group.js.map
